// Header behaviour (issue 27): the phone menu dialog and the pincode bar's form. The form sends
// a `cck:pincode` event; cck-region.js (issue 28) looks it up and answers with `cck:region`,
// which updates every pincode bar here. Loaded before cck-region.js so it hears the first answer.

function updatePincodeBars(
  /** @type {{ region: string | null, label: string, pincode: string }} */ d,
) {
  for (const bar of document.querySelectorAll("[data-cck-pincode-bar]")) {
    const showing = bar.querySelector("[data-cck-pincode-showing]");
    const prompt = bar.querySelector("[data-cck-pincode-prompt]");
    const strong = bar.querySelector("[data-cck-region-label]");
    const input = bar.querySelector("[data-cck-pincode-input]");
    if (input instanceof HTMLInputElement && d.pincode) input.value = d.pincode;
    if (!showing || !prompt || !strong) continue;
    showing.hidden = false;
    prompt.hidden = true;
    strong.textContent = d.label;
  }
}

function setUpMenu() {
  const dialog = document.querySelector("[data-cck-menu]");
  if (!(dialog instanceof HTMLDialogElement)) return;
  const opener = document.querySelector("[data-cck-menu-open]");
  opener?.addEventListener("click", () => {
    dialog.showModal();
    opener.setAttribute("aria-expanded", "true");
  });
  dialog.querySelector("[data-cck-menu-close]")?.addEventListener("click", () => dialog.close());
  dialog.addEventListener("close", () => opener?.setAttribute("aria-expanded", "false"));
  // A tap on the backdrop closes it too.
  dialog.addEventListener("click", (e) => {
    if (e.target === dialog) dialog.close();
  });
  // Opening the menu at a phone width and then widening the window leaves no stray dialog.
  matchMedia("(min-width: 1240px)").addEventListener("change", (e) => {
    if (e.matches) dialog.close();
  });
}

function setUpPincodeBars() {
  for (const bar of document.querySelectorAll("[data-cck-pincode-bar]")) {
    const input = bar.querySelector("[data-cck-pincode-input]");
    if (!(bar instanceof HTMLFormElement) || !(input instanceof HTMLInputElement)) continue;
    input.addEventListener("input", () => {
      input.value = input.value.replace(/\D/g, "").slice(0, 6);
      input.removeAttribute("aria-invalid");
    });
    bar.addEventListener("submit", (e) => {
      e.preventDefault();
      const pincode = input.value.trim();
      const valid = /^[1-9]\d{5}$/.test(pincode);
      input.setAttribute("aria-invalid", String(!valid));
      const hint = bar.querySelector("[data-cck-location-status]");
      if (!valid) {
        if (hint) hint.textContent = "A pincode is six digits, like 201304.";
        input.focus();
        return;
      }
      if (hint) hint.textContent = "";
      document.dispatchEvent(new CustomEvent("cck:pincode", { detail: { pincode } }));
    });
  }
}

document.addEventListener("cck:region", (e) => {
  updatePincodeBars(/** @type {CustomEvent} */ (e).detail);
});

setUpMenu();
setUpPincodeBars();
